var _g, _rect, _g2, _rect2, _path, _rect3, _path2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 65",
    preserveAspectRatio: "xMidYMid meet",
    shapeRendering: "optimizeQuality",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 27.551194186166395,
    height: 50.000352412192655,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.560001373291016 59.09000015258789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e61f2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.49 58.11h32.07v.98H.49zM.49 0h32.07v.98H.49zM9.74 31.42h22.14v-.97H9.26l-8.29-.01H0v20.41h32.55v-.98H9.74V31.42zM9.26 8.24H0v14.93h8.77v.01h23.11v-.97H9.74V9.22h22.81v-.98H9.26z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.551194186166395, 0)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 27.541871965053733,
    height: 49.99976756418149,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 27.541871965053733,
    height: 49.99976756418149,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.560001373291016 59.11000061035156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#76bd4e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.49 58.13h32.07v.98H.49zM9.74 0H0v50.87h.97l8.29-.01h23.29v-.97H9.74V0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.09306615122013, 0)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#feffff",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 43.942657147161526,
    height: 50.000178809992065,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 43.942657147161526,
    height: 50.000178809992065,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.029998779296875 60.34000015258789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#76bd4e",
    d: "M42.38 0L26.41 35.55 10.64 0H9.59l16.55 37.51-4.08 10.06L1.05 0H0l26.21 60.34L53.03 0H42.38z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.03572329838165, 0)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 50.33299578440415,
    height: 49.99999581229426,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 50.33299578440415,
    height: 49.99999581229426,
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.69439697265625 61.28623580932617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.66 9A29.65 29.65 0 0 0 31 0 30.21 30.21 0 0 0 9.14 9 29.06 29.06 0 0 0 0 30.37c0 9.42 3.37 17.14 10 23a30.57 30.57 0 0 0 20.53 7.91 30.6 30.6 0 0 0 22.06-8.9 29.19 29.19 0 0 0 9.1-21.62A29.62 29.62 0 0 0 52.66 9zm-22 43a20.41 20.41 0 0 1-14.52-6 20.65 20.65 0 0 1-6.32-15.51 20.54 20.54 0 0 1 6.11-15.09 20.31 20.31 0 0 1 15-6.18 20.11 20.11 0 0 1 14.9 6.18 20.89 20.89 0 0 1 6.07 15.24 21 21 0 0 1-6.14 15.23 20.54 20.54 0 0 1-15.09 6.18zm21.27-.42a29.66 29.66 0 0 1-21.08 8.62V53a21.47 21.47 0 0 0 15.59-6.46 22 22 0 0 0 6.43-15.92 21.88 21.88 0 0 0-6.35-15.93A21.07 21.07 0 0 0 30.9 8.24V1h.1a28.72 28.72 0 0 1 21 8.72 28.69 28.69 0 0 1 8.78 21 28.26 28.26 0 0 1-8.84 20.91z",
    fill: "#e61f2f"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    fill: "#777",
    transform: "translate(10,62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08-7.87L1.08 0L3.10 0C3.69 0 4.21-0.09 4.67-0.27C5.12-0.45 5.51-0.71 5.82-1.05C6.13-1.39 6.37-1.81 6.53-2.30C6.69-2.79 6.77-3.35 6.77-3.97C6.77-5.23 6.45-6.19 5.82-6.86C5.19-7.54 4.26-7.87 3.05-7.87ZM2.98-0.82L2.08-0.82L2.08-7.06L2.98-7.06C3.90-7.06 4.59-6.79 5.05-6.26C5.51-5.74 5.74-4.97 5.74-3.97C5.74-2.97 5.51-2.20 5.05-1.64C4.59-1.09 3.90-0.82 2.98-0.82ZM8.46-7.87L8.46 0L9.46 0L9.46-7.87ZM11.16-3.94C11.16-3.30 11.25-2.72 11.42-2.21C11.60-1.71 11.84-1.28 12.16-0.93C12.47-0.58 12.84-0.32 13.27-0.13C13.70 0.05 14.18 0.14 14.70 0.14C15.23 0.14 15.70 0.06 16.12-0.11C16.54-0.29 16.88-0.50 17.14-0.77L17.14-4.08L14.56-4.08L14.56-3.25L16.22-3.25L16.22-1.20C16.06-1.06 15.86-0.94 15.61-0.86C15.35-0.77 15.09-0.73 14.81-0.73C14.38-0.73 14.01-0.81 13.69-0.96C13.36-1.11 13.09-1.33 12.87-1.61C12.65-1.89 12.48-2.23 12.37-2.62C12.25-3.02 12.19-3.46 12.19-3.96C12.19-4.45 12.25-4.89 12.38-5.28C12.50-5.67 12.68-6.01 12.90-6.28C13.12-6.56 13.40-6.77 13.72-6.92C14.04-7.07 14.40-7.14 14.80-7.14C15.20-7.14 15.53-7.07 15.79-6.93C16.05-6.79 16.28-6.62 16.48-6.41L17.04-7.04C16.81-7.28 16.51-7.51 16.15-7.71C15.78-7.91 15.33-8.02 14.78-8.02C14.26-8.02 13.77-7.92 13.33-7.73C12.89-7.55 12.51-7.28 12.19-6.92C11.86-6.57 11.61-6.14 11.43-5.64C11.25-5.14 11.16-4.57 11.16-3.94ZM19.02-7.87L19.02 0L20.02 0L20.02-7.87ZM23.81-7.03L23.81 0L24.82 0L24.82-7.03L27.19-7.03L27.19-7.87L21.43-7.87L21.43-7.03ZM31.48-3.20L29.11-3.20L29.48-4.40C29.63-4.84 29.76-5.28 29.89-5.72C30.02-6.15 30.14-6.60 30.26-7.06L30.31-7.06C30.44-6.60 30.57-6.15 30.70-5.72C30.82-5.28 30.96-4.84 31.10-4.40ZM31.73-2.40L32.47 0L33.54 0L30.88-7.87L29.75-7.87L27.08 0L28.10 0L28.86-2.40ZM34.66-7.87L34.66 0L39.10 0L39.10-0.85L35.65-0.85L35.65-7.87Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74b822280efecbf10bd07b8a5f4c5917.svg";
export { ForwardRef as ReactComponent };